module.exports = __webpack_public_path__ + "static/media/baby-min.a90c8109.png";